import { render, staticRenderFns } from "./airValveSouthChannelMainTower.vue?vue&type=template&id=c1b3b856&scoped=true"
import script from "./airValveSouthChannelMainTower.vue?vue&type=script&lang=js"
export * from "./airValveSouthChannelMainTower.vue?vue&type=script&lang=js"
import style0 from "./airValveSouthChannelMainTower.vue?vue&type=style&index=0&id=c1b3b856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b3b856",
  null
  
)

export default component.exports